<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<div class="border p-3">
  @if (enrolledTANDevices) {
    @if (tanMode) {
      @if (!tanSuccessfullySent) {
        <div class="d-flex flex-column align-items-center">
          @if (appAuthEnabled) {
            <p class="text-center text-default">
              TIPP: Nutze unsere
              <a
                href="https://finanzen.net/zero/securetan"
                target="_blank"
                rel="noopener noreferrer"
                class="link link-secondary text-default"
                ><span class="text-nowrap">Secure TAN App</span></a
              >
              zur sicheren und komfortablen Autorisierung.
            </p>
          }
          <p class="text-size-large text-center">
            Fordere zur Freigabe der
            {{ isTradingSessionAuth ? 'Handelssession' : 'Transaktion' }} eine TAN an.
          </p>
          <div class="d-flex justify-content-center">
            <web-design-system-button size="small" data-zid="get-tan" (click)="initiateTanAuth()">
              {{ 'transaction-authorization.sms' | transloco }}
            </web-design-system-button>
            @if (ttsEnabled) {
              <web-design-system-button size="small" class="ml-1 ml-sm-3" (click)="initiateTanAuth(true)">
                {{ 'transaction-authorization.call' | transloco }}
              </web-design-system-button>
            }
          </div>
        </div>
      }
      @if (!!tanSuccessfullySent && !transactionCreated) {
        <div class="font-size-smaller1 main-font-family text-align-center">
          @if (!lastTanWasTts) {
            Deine TAN ist per SMS unterwegs ({{ lastTanRequested | date: 'mediumTime' }} Uhr an {{ verifiedPhoneNumber }}).
          }
          @if (lastTanWasTts) {
            Deine TAN ist per Sprachanruf unterwegs ({{ lastTanRequested | date: 'mediumTime' }} Uhr von {{ getSpeechNr() }}).
          }
        </div>
      }
      @if (!!tanSuccessfullySent && !transactionCreated) {
        <form #f="ngForm">
          @if (tanval.invalid || tanval.pristine || !tanSuccessfullySent || errors.length > 0) {
            <div class="row mt-1 justify-content-center">
              <div class="col-12 font-size-smaller1 text-align-center">
                @if (offerTanResend) {
                  TAN nicht erhalten?
                  <a
                    class="link link-secondary font-size-smaller1"
                    href="javascript:void(0)"
                    (click)="initiateTanAuth(lastTanWasTts, tanval)"
                  >
                    Erneut anfordern
                  </a>
                }
                @if (!offerTanResend) {
                  Bitte warte einen Moment ...
                }
              </div>
            </div>
          }
          <div class="row mt-4">
            <div class="col-6" [class.col-12]="!tanval.value || transactionCreated">
              <div class="input-group-material" [class.input-group-material--error]="tanval.touched && tanval.invalid">
                <input
                  id="taninput"
                  type="text"
                  autocomplete="off"
                  data-zid="tan"
                  required
                  zeroAutofocus
                  pattern="[0-9]{6}"
                  name="taninput"
                  ngModel
                  #tanval="ngModel"
                  #taninput
                  [class.empty]="!tanval.value"
                  maxlength="6"
                  (input)="tanInputValueChange()"
                />
                <div class="input-group-material-icon-state"></div>
                <label for="taninput" [class.rised]="tanval.value">TAN</label>
                @if (tanval.touched && tanval.invalid) {
                  <div class="input-group-material-message">Bitte gib eine gültige TAN ein.</div>
                }
              </div>
            </div>
            @if (tanval.value && !transactionCreated) {
              <div class="col-12 d-flex justify-content-center mt-2">
                <web-design-system-button
                  data-zid="check-tan"
                  (click)="createTransaction(tanval.value)"
                  [disabled]="f.invalid"
                  size="small"
                >
                  TAN prüfen
                </web-design-system-button>
              </div>
            }
          </div>
        </form>
      }
    }
    @if (appMode) {
      <div class="d-flex flex-column align-items-center">
        @if (!transactionAbortedThroughApp && !transactionCreated) {
          @if (enrolledTANDevices.length > 1) {
            <div class="pr-5">
              <div
                class="input-group-material select-dropdown dropdown-authdevices mt-3"
                [class.input-group-material--error]="chooseDeviceVar.invalid && chooseDeviceVar.touched"
              >
                <select
                  [(ngModel)]="chosenTANDeviceName"
                  name="chooseDeviceSelect"
                  id="chooseDeviceSelect"
                  (ngModelChange)="chooseInitiateAppAuth()"
                  #chooseDeviceVar="ngModel"
                  [class.empty]="!chooseDeviceVar.value"
                  required
                >
                  @for (device of enrolledTANDevices; track device.serial) {
                    <option [value]="device.customerDeviceName">
                      {{ device.customerDeviceName }}
                    </option>
                  }
                </select>
                <label for="chooseDeviceSelect">Auswahl Autorisierungsgerät</label>
                @if (!chooseDeviceVar.value || chooseDeviceVar.valid) {
                  <div class="input-group-material-message">&nbsp;</div>
                }
              </div>
            </div>
          }
        }
        @if (waitingForTransactionAuth) {
          <div>
            <p class="mb-0 text-center">
              Bitte gib die
              {{ isTradingSessionAuth ? 'Handelssession' : 'Transaktion' }} in der Secure TAN App auf
              <strong>{{ chosenTANDeviceName }}</strong> frei.
            </p>
          </div>
        }
        @if (transactionAbortedThroughApp) {
          <div class="d-flex justify-content-center">
            @if (!isTradingSessionAuth) {
              Die Transaktion wurde abgebrochen.
            }
            @if (isTradingSessionAuth) {
              Die Freigabe der Handelssession wurde abgebrochen.
            }
          </div>
        }
        @if (!transactionAbortedThroughApp && !transactionCreated) {
          <div class="font-size-smaller2">
            <a class="link link-underline link-primary" href="javascript:void(0)" (click)="switchToTanMode()">
              Zur Freigabe mittels SMS-TAN wechseln.
            </a>
          </div>
        }
      </div>
    }
    @if (transactionCreated) {
      <div>
        @if (!isTradingSessionAuth) {
          <div>Die Transaktion wurde erfolgreich durchgeführt.</div>
          @if (isPreAuthorizationPayload) {
            <div><br />Gleich geht es weiter...</div>
          }
        }
        @if (isTradingSessionAuth) {
          Deine Handelssession wurde erfolgreich freigegeben.
        }
      </div>
    }
    @if (!transactionCreated) {
      <div class="mt-3 d-flex justify-content-center">
        <a class="link-secondary font-size-smaller2" href="javascript:void(0)" (click)="cancelAuth()"> Autorisierung abbrechen </a>
      </div>
    }
  }
  <div class="mt-2">
    @for (msg of errors; track $index) {
      <p class="text-color-error text-center">{{ msg }}</p>
    }
  </div>
</div>
